/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseRatingFieldType } from './DatabaseRatingFieldType';
import {
    DatabaseRatingFieldTypeFromJSON,
    DatabaseRatingFieldTypeFromJSONTyped,
    DatabaseRatingFieldTypeToJSON,
} from './DatabaseRatingFieldType';

/**
 * 
 * @export
 * @interface DatabaseRatingField
 */
export interface DatabaseRatingField extends DatabaseField {
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    color?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseRatingField
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseRatingField
     */
    showDontKnow?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    iconClass?: string;
    /**
     * 
     * @type {DatabaseRatingFieldType}
     * @memberof DatabaseRatingField
     */
    type?: DatabaseRatingFieldType;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor1?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor2?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor3?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor4?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor5?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor6?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor7?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor8?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor9?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor10?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingColor11?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseRatingField
     */
    ratingLabelColor?: string;
}

/**
 * Check if a given object implements the DatabaseRatingField interface.
 */
export function instanceOfDatabaseRatingField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseRatingFieldFromJSON(json: any): DatabaseRatingField {
    return DatabaseRatingFieldFromJSONTyped(json, false);
}

export function DatabaseRatingFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseRatingField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'color': !exists(json, 'color') ? undefined : json['color'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'showDontKnow': !exists(json, 'showDontKnow') ? undefined : json['showDontKnow'],
        'iconClass': !exists(json, 'iconClass') ? undefined : json['iconClass'],
        'type': !exists(json, 'type') ? undefined : DatabaseRatingFieldTypeFromJSON(json['type']),
        'ratingColor1': !exists(json, 'ratingColor1') ? undefined : json['ratingColor1'],
        'ratingColor2': !exists(json, 'ratingColor2') ? undefined : json['ratingColor2'],
        'ratingColor3': !exists(json, 'ratingColor3') ? undefined : json['ratingColor3'],
        'ratingColor4': !exists(json, 'ratingColor4') ? undefined : json['ratingColor4'],
        'ratingColor5': !exists(json, 'ratingColor5') ? undefined : json['ratingColor5'],
        'ratingColor6': !exists(json, 'ratingColor6') ? undefined : json['ratingColor6'],
        'ratingColor7': !exists(json, 'ratingColor7') ? undefined : json['ratingColor7'],
        'ratingColor8': !exists(json, 'ratingColor8') ? undefined : json['ratingColor8'],
        'ratingColor9': !exists(json, 'ratingColor9') ? undefined : json['ratingColor9'],
        'ratingColor10': !exists(json, 'ratingColor10') ? undefined : json['ratingColor10'],
        'ratingColor11': !exists(json, 'ratingColor11') ? undefined : json['ratingColor11'],
        'ratingLabelColor': !exists(json, 'ratingLabelColor') ? undefined : json['ratingLabelColor'],
    };
}

export function DatabaseRatingFieldToJSON(value?: DatabaseRatingField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'color': value.color,
        'amount': value.amount,
        'showDontKnow': value.showDontKnow,
        'iconClass': value.iconClass,
        'type': DatabaseRatingFieldTypeToJSON(value.type),
        'ratingColor1': value.ratingColor1,
        'ratingColor2': value.ratingColor2,
        'ratingColor3': value.ratingColor3,
        'ratingColor4': value.ratingColor4,
        'ratingColor5': value.ratingColor5,
        'ratingColor6': value.ratingColor6,
        'ratingColor7': value.ratingColor7,
        'ratingColor8': value.ratingColor8,
        'ratingColor9': value.ratingColor9,
        'ratingColor10': value.ratingColor10,
        'ratingColor11': value.ratingColor11,
        'ratingLabelColor': value.ratingLabelColor,
    };
}

